import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'

/**
 * @description: 横板视频16:9
 */
const HORIZONTAL_VIDEO = 720

/**
 * @description: 竖版视频9:16
 */
const VERTICAL_VIDEO = 721

/**
 * @description: 横板大图16:9
 */
const HORIZONTAL_LARGE_IMG = 711

/**
 * @description: 竖版大图9:16
 */
const VERTICAL_LARGE_IMG = 712

/**
 * @description: 横板小图3:2
 */
const HORIZONTAL_TINY_IMG = 714

/**
 * @description: 横板三小图3:2
 */
const HORIZONTAL_THREE_TINY_IMG = 718

/**
 * @description: 方形大图1:1
 */
const NORMAL_LARGE_IMG = 717

/**
 * @description: 腾讯ada创意形象列表
 */
export const CREATIVE_TYPES = [
  {
    label: '横板视频16:9',
    value: HORIZONTAL_VIDEO
  },
  {
    label: '竖版视频9:16',
    value: VERTICAL_VIDEO
  },
  {
    label: '横板大图16:9',
    value: HORIZONTAL_LARGE_IMG
  },
  {
    label: '竖版大图9:16',
    value: VERTICAL_LARGE_IMG
  },
  {
    label: '横板小图3:2',
    value: HORIZONTAL_TINY_IMG
  },
  {
    label: '横板三小图3:2',
    value: HORIZONTAL_THREE_TINY_IMG
  },
  {
    label: '方形大图1:1',
    value: NORMAL_LARGE_IMG
  }
]

/**
 * @description: 手动将属性排序，数字越小越靠前
 * @return {*}
 */
export const SORT_LABEL = {
  video_options: 0,
  image_options: 1,
  element_story: 1,
  brand: 3,
  floating_zone_struct: 8,
  wechat_channels_spec: 9,
  end_page: 17,
  description: 18,
  button_text: 19,
  description_options: 19,
  finder_object_visibility: 19,
  label: 20
}

const BRAND_TYPE_PROFILE = 2
const BRAND_TYPE_BRAND = 3
const BRAND_TYPE_WECHAT_CHANNEL = 1
const BRAND_TYPE_OFFICIAL_ACCOUNT = 4
export const BRAND_ENUM = {
  PROFILE: BRAND_TYPE_PROFILE,
  CHANNEL: BRAND_TYPE_WECHAT_CHANNEL,
  BRAND: BRAND_TYPE_BRAND,
  OFFICIAL_ACCOUNT: BRAND_TYPE_OFFICIAL_ACCOUNT
}
export const BRAND_LIST = [
  {
    label: '品牌简介页',
    value: BRAND_ENUM.PROFILE
  },
  {
    label: '品牌跳转',
    value: BRAND_ENUM.BRAND
  },
  {
    label: '视频号',
    value: BRAND_ENUM.CHANNEL
  },
  {
    label: '公众号',
    value: BRAND_ENUM.OFFICIAL_ACCOUNT
  }
]

export const MATERIAL_SIZES = {
  SIZE_456_300: '456*300',
  SIZE_500_500: '500*500',
  SIZE_800_800: '800*800',
  SIZE_1280_720: '1280*720',
  SIZE_720_1280: '720*1280',
  SIZE_1080_1920: '1080*1920',
  SIZE_1920_1080: '1920*1080'
}

/**
 * @description: 创意形式分配方式：自动匹配 手动匹配
 * @return {*}
 */
export const DYNAMIC_CREATIVE_TYPE = {
  PROGRAM: 'DYNAMIC_CREATIVE_TYPE_PROGRAM',
  COMMON: 'DYNAMIC_CREATIVE_TYPE_COMMON'
}
export const DYNAMIC_CREATIVE_TYPE_LIST = [
  {
    label: '自动匹配',
    value: DYNAMIC_CREATIVE_TYPE.PROGRAM
  },
  {
    label: '手动匹配',
    value: DYNAMIC_CREATIVE_TYPE.COMMON
  }
]
export const CREATIVE_TEMPLATE_LIST = [
  { id: 910, label: '激励浏览计划' },
  { id: 2688, label: '轮播三图' },
  { id: 2888, label: '轮播三视频' }
]
export const MATERIAL_TYPE_SIZES = {
  [MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO]]: [
    { label: MATERIAL_SIZES.SIZE_456_300 },
    { label: MATERIAL_SIZES.SIZE_800_800 },
    { label: MATERIAL_SIZES.SIZE_1280_720 },
    { label: MATERIAL_SIZES.SIZE_720_1280 }
  ],
  [MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]]: [
    { label: '不限' },
    { label: MATERIAL_SIZES.SIZE_456_300 },
    { label: MATERIAL_SIZES.SIZE_800_800 },
    { label: MATERIAL_SIZES.SIZE_1280_720 },
    { label: MATERIAL_SIZES.SIZE_720_1280 },
    { label: MATERIAL_SIZES.SIZE_1080_1920 }
  ],
  [MATERIAL_TYPE_ID[MATERIAL_TYPE.POSTER]]: [],
  [MATERIAL_TYPE_ID[MATERIAL_TYPE.LOGO]]: [{ label: MATERIAL_SIZES.SIZE_500_500 }]
}
export const MATERIAL_TYPE_SIZES_V3 = {
  [MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO]]: [
    { label: MATERIAL_SIZES.SIZE_1280_720 },
    { label: MATERIAL_SIZES.SIZE_720_1280 },
    { label: MATERIAL_SIZES.SIZE_1080_1920 },
    { label: MATERIAL_SIZES.SIZE_1920_1080 }
  ],
  [MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]]: [
    { label: MATERIAL_SIZES.SIZE_1280_720 },
    { label: MATERIAL_SIZES.SIZE_720_1280 },
    { label: MATERIAL_SIZES.SIZE_1080_1920 },
    { label: MATERIAL_SIZES.SIZE_1920_1080 },
    { label: MATERIAL_SIZES.SIZE_800_800 }
  ],
  [MATERIAL_TYPE_ID[MATERIAL_TYPE.GROUP_IMAGE]]: [],
  [MATERIAL_TYPE_ID[MATERIAL_TYPE.POSTER]]: [],
  [MATERIAL_TYPE_ID[MATERIAL_TYPE.LOGO]]: [{ label: MATERIAL_SIZES.SIZE_1280_720 }, { label: MATERIAL_SIZES.SIZE_800_800 }]
}

export const MATERIAL_IMAGE_GROUP_TYPE = {
  THREE_IMAGE: 3,
  FOUR_IMAGE: 4,
  SIX_IMAGE: 6,
  NINE_IMAGE: 9
}

export const DELIVERY_MODE = {
  COMPONENT: 'DELIVERY_MODE_COMPONENT',
  CUSTOMIZE: 'DELIVERY_MODE_CUSTOMIZE'
}

export const DELIVERY_MODE_LIST = [
  {
    label: '组件化创意',
    value: DELIVERY_MODE.COMPONENT
  },
  {
    label: '自定义创意',
    value: DELIVERY_MODE.CUSTOMIZE
  }
]

export const LINK_NAME_TYPE = [
  {
    label: '立即下载',
    value: 'DOWNLOAD_NOW'
  },
  {
    label: '立即预约',
    value: 'RESERVE_NOW'
  },
  {
    label: '了解更多',
    value: 'MORE_INFO'
  },
  {
    label: '立即试玩',
    value: 'TRY_PLAY_NOW'
  },
  {
    label: '立即安装',
    value: 'INSTALL_NOW'
  },
  {
    label: '下载应用',
    value: 'DOWNLOAD_APP'
  },
  {
    label: '下载游戏',
    value: 'DOWNLOAD_GAME'
  },
  {
    label: '立即秒杀',
    value: 'SECKILL_NOW'
  }
]

export const LINK_NAME_TYPE_NORMAL = [
  {
    value: 'DOWNLOAD_APP',
    label: '下载应用'
  },
  {
    value: 'DOWNLOAD_GAME',
    label: '下载游戏'
  },
  {
    value: 'MORE_INFO',
    label: '了解更多'
  }
]
export const LINK_NAME_TYPE_MINIGAME = [
  {
    value: 'ENTER_MINI_GAME',
    label: '进入小游戏'
  },
  {
    value: 'TRY_NOW',
    label: '立即体验'
  },
  {
    value: 'MORE_INFO',
    label: '了解更多'
  },
  {
    value: 'TRY_PLAY_NOW',
    label: '立即试玩'
  },
  {
    value: 'OPEN_MINI_GAME',
    label: '打开游戏'
  },
  {
    value: 'PLAY_NOW',
    label: '立即玩'
  }
]

/**
 * @description: 试玩营销组件的按钮文案
 * @return {*}
 */
export const LINK_NAME_TYPE_WXGAME_PLAYABLE = [
  '立即试玩',
  '点击即玩',
  '点击试玩',
  '现在试玩',
  '进入试玩',
  '去试玩',
  '打开试玩',
  '玩玩看',
  '体验游戏',
  '试玩一下',
  '一键试玩'
]

/**
 * @description: 数据外显数据类型
 * @return {*}
 */
export const CONVERSION_DATA = {
  APP_DOWNLOAD: 'CONVERSION_DATA_APP_DOWNLOAD',
  ADMETRIC: 'CONVERSION_DATA_ADMETRIC'
}
export const CONVERSION_DATA_TYPE_LIST = [
  {
    label: '应用下载量',
    value: CONVERSION_DATA.APP_DOWNLOAD
  },
  {
    label: '转化数据量',
    value: CONVERSION_DATA.ADMETRIC
  }
]

/**
 * @description: 小游戏平台的外显数据转化目标
 * @return {*}
 */
export const MINIGAME_CONVERSION_TARGET_LIST = [
  {
    value: 'CONVERSION_TARGET_PLAYING',
    label: '在玩'
  }
]

/**
 * @description: 应用平台的外显数据转化目标
 * @return {*}
 */
export const APP_CONVERSION_TARGET_LIST = [
  {
    value: 'CONVERSION_TARGET_GET',
    label: '领取'
  },
  {
    value: 'CONVERSION_TARGET_RESERVE',
    label: '预约'
  },
  {
    value: 'CONVERSION_TARGET_APPLY',
    label: '申请'
  },
  {
    value: 'CONVERSION_TARGET_DOWNLOAD',
    label: '下载'
  }
]

export const END_PAGE_AVATAR_NICKNAME_HIGHLIGHT = 'END_PAGE_AVATAR_NICKNAME_HIGHLIGHT'
export const END_PAGE_DESCRIPTION_HIGHLIGHT = 'END_PAGE_DESCRIPTION_HIGHLIGHT'
export const END_PAGE_TYPE_LIST = [
  {
    label: '突出头像及昵称',
    value: END_PAGE_AVATAR_NICKNAME_HIGHLIGHT
  },
  {
    label: '突出文案',
    value: END_PAGE_DESCRIPTION_HIGHLIGHT
  }
]
export const PAGE_TYPES = {
  WECHAT_MINI_GAME: 'PAGE_TYPE_WECHAT_MINI_GAME',
  OFFICIAL: 'PAGE_TYPE_OFFICIAL',
  IOS_APP: 'PAGE_TYPE_IOS_APP',
  XJ_QUICK: 'PAGE_TYPE_XJ_QUICK'
}

export const PAGE_TYPE_LIST = [
  {
    label: '微信小游戏',
    value: PAGE_TYPES.WECHAT_MINI_GAME
  },
  {
    label: '官方落地页',
    value: PAGE_TYPES.OFFICIAL
  },
  {
    label: '微信小游戏',
    value: PAGE_TYPES.IOS_APP
  },
  {
    label: '微信小游戏',
    value: PAGE_TYPES.XJ_QUICK
  }
]

/**
 * @description: 创意组件选择logo类型
 * @return {*}
 */
export const SELECTOR_TYPE = {
  MINI_CARD_LINK: 'mini_card_link',
  FLOATING_ZONE: 'floating_zone',
  WXGAME_PLAYABLE: 'wxgame_playable'
}

export const WXGAME_PLAYABLE_TRIGGER_TYPE = {
  CARD: 'WXGAME_PLAYABLE_PAGE_TRIGGER_TYPE_CARD_LINK',
  MASK: 'WXGAME_PLAYABLE_PAGE_TRIGGER_TYPE_MASK'
}

// 小游戏试玩页组件结束时间类型
export const WXGAME_PLAYABLE_PAGE_END_TIME = {
  UNKNOWN: 'WXGAME_PLAYABLE_PAGE_END_TYPE_UNKNOWN', // 未知
  THIRTY_SECONDS: 'WXGAME_PLAYABLE_PAGE_END_TIME_30', // 30 秒
  COMPLETE: 'WXGAME_PLAYABLE_PAGE_END_TIME_COMPLETE' // 完整播放
}

export const WXGAME_PLAYABLE_PAGE_TRIGGER_TYPES = [
  {
    label: '图文链接',
    value: WXGAME_PLAYABLE_TRIGGER_TYPE.CARD
  },
  {
    label: '引导蒙层',
    value: WXGAME_PLAYABLE_TRIGGER_TYPE.MASK
  }
]
